import { Feature, FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import { asQuantityWithUnit } from './formatters';

type ParsedGeoJson = FeatureCollection | Feature | Polygon | MultiPolygon;

const parsedJsonToFeatures = (geojson: ParsedGeoJson) => {
  let features: Feature<Polygon | MultiPolygon>[] = [];
  let featureCount = 0;
  const errors: string[] = [];
  const warnings: string[] = [];
  if (geojson.type === 'FeatureCollection') {
    featureCount = geojson.features.length;
    features = geojson.features.filter((f, i) => {
      const { name: displayName = `Feature ${i + 1}` } = f?.properties || {};
      const valid =
        f.geometry &&
        (f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon');
      if (!valid) {
        errors.push(
          `${displayName}: geometry type must be a Polygon or MultiPolygon.`,
        );
      }
      return valid;
    }) as Feature<Polygon | MultiPolygon>[];
  } else if (
    geojson.type === 'Feature' &&
    geojson.geometry &&
    (geojson.geometry.type === 'Polygon' ||
      geojson.geometry.type === 'MultiPolygon')
  ) {
    featureCount = 1;
    features = [geojson as Feature<Polygon | MultiPolygon>];
  } else if (geojson.type === 'Polygon' || geojson.type === 'MultiPolygon') {
    featureCount = 1;
    features = [
      {
        type: 'Feature',
        geometry: geojson,
        properties: {},
      } as Feature<Polygon | MultiPolygon>,
    ];
  } else {
    errors.push(`Each feature must be a Polygon or MultiPolygon.`);
  }

  if (!features.length) {
    warnings.push('No valid features found.');
  }

  const info =
    warnings.length + errors.length
      ? `Imported ${asQuantityWithUnit(
          'valid features',
          'valid feature',
        )(features.length)}. ${asQuantityWithUnit(
          'features',
          'feature',
        )(featureCount - features.length)} discarded due to errors.`
      : undefined;

  return { features, info, warnings, errors };
};

export default parsedJsonToFeatures;
